var _circle, _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLinkedinAlt = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19.3947,
    r: 19.3947,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0491 26.4473V26.4467H27.0526V21.2736C27.0526 18.7429 26.5078 16.7935 23.5492 16.7935C22.1269 16.7935 21.1724 17.5739 20.7828 18.3139H20.7417V17.0297H17.9365V26.4467H20.8574V21.7838C20.8574 20.556 21.0902 19.3688 22.6106 19.3688C24.1087 19.3688 24.131 20.77 24.131 21.8625V26.4473H27.0491Z",
    fill: "#626A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1801 17.0303H16.1045V26.4473H13.1801V17.0303Z",
    fill: "#626A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6411 12.342C13.7061 12.342 12.9473 13.1008 12.9473 14.0358C12.9473 14.9709 13.7061 15.7455 14.6411 15.7455C15.5762 15.7455 16.3349 14.9709 16.3349 14.0358C16.3344 13.1008 15.5756 12.342 14.6411 12.342V12.342Z",
    fill: "#626A77"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedinAlt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedin-alt.cae6c959.svg";
export { ForwardRef as ReactComponent };